const SavingsInitialArray =[
    {savingsType: "default", totalSavingsAmt: 0, intEarned: 0, intRate: 0, 
        oneTimeDepositAmt: 0, monthlyDepositAmt: 0, prevTransferAmt: 0,
        prevTransferFees: 0, newTransferAmt: 0, newTransferFee: 0, nbrTransfers: 0, 
        currentMonthlyAmt: 0, updated: false, yearArr: [], totalDeposited: 0,
        createNewElementSw: true, svgIndx: null, startDate: "", savingsClass: "",
    },
    {savingsType: "CD", autoRollover: true},
   
  ]
export default SavingsInitialArray;